import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

// Fact-only, no note content -- notes can run to 1500 chars (TRIP_LIST_NOTE_MAX_LENGTH) against
// this entry's 200-char server cap, so embedding the note text would almost always truncate it
// mid-sentence. The note content itself is already visible to the model via itinerary data.
//
// occurredAt is the caller's timestamp, not one taken here -- see
// buildItemStatusChangedActivityEntry for why (same useMutation onSuccess shape).
export function buildItemNoteUpdatedActivityEntry(title: string, occurredAt: string): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'item_note_updated',
    label: 'Updated itinerary item note',
    displayText: boundActivityDisplayText(`Updated note for "${title}"`),
    sourcePath: 'trip_planner.list.note_update',
    dataClassification: 'personalised_surface',
    occurredAt,
  }
}
